import React, { Component } from "react";
import "./venta.scss";
import { Col, Container, Row } from 'bootstrap-4-react';
import { withRouter, } from "react-router-dom";
import Select from 'react-select'
import moment from 'moment'
import ItemsCarousel from 'react-items-carousel';
import Lottie from 'lottie-react-web'
import animationData from "../../../lotties/33623-piggy-bank-loop.json";

const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
const customStyles = {
  control: styles => ({ ...styles, backgroundColor: '#fff', height: 42, width: '90%', margin: '0 auto', marginBottom: 20, }),
}

class MainProgresoPage extends Component {
  constructor(props) {
    super(props);
    this.__getProgreso = this.__getProgreso.bind(this)
    this.state = {
      __getProgreso: this.__getProgreso,
      arraySucursales: [],
      id_sucursal: '0',
      date: moment().format('YYYY-MM-DD'),
      typeProduct: 0,
      arrDiasVenta: [],
      arrDiasGasto: [],
      arrHistoryVentas: [],
      totalVentas: {
        kg: 0,
        pesos: 0,
        pesosMesAnterior: 0,
      },
      totalGastos: {
        gastos: 0,
      },
      isLoading: false,
      groupBy: 'sucursal',
      indexViewProducts: -1,

      //Carousel items
      children: [],
      activeItemIndex: 0,

      //
      arrListUtilidades: [],

    }
  }

  __getProgreso() {
    this.getProgreso()
  }

  getDateGeneric(opt) {
    if(opt === 0)
      return (new Date())
    else {
      let d = new Date()
      // d.setMonth(5) // Junio
      // d.setDate(30)
      return new Date(d)
    }

  }

  componentDidMount() {
    //Petition wuuuu
    this.getProgreso()
    this.props.onRef(this)
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  getAlert() {
    alert('clicked');
 }

  getProgreso() {
    const { id_sucursal, date, typeProduct, groupBy } = this.state

    const data = {
      user: 'admin',
      tab: this.props.initState.tabProgresoActive,
      id_sucursal,
      date,
      typeProduct,
      groupBy
    }

    fetch(this.getURLByOPT('appProgreso'), this.headersPOST({...data}))
    .then(response => response.json())
    .then((response) => {
      let { arraySucursales, arrDiasVenta, arrDiasGasto, } = response
      let { total_pesos, total_kg, total_pesos_before, } = arrDiasVenta

      this.setState({
        arraySucursales,
        arrDiasVenta: arrDiasVenta.array,
        arrDiasGasto: arrDiasGasto.array,
        totalVentas: {
          kg: total_kg,
          pesos: total_pesos,
          pesosMesAnterior: total_pesos_before,
        },
        totalGastos: {
          gastos: arrDiasGasto.total_gastos
        },
        isLoading: false,
      })

      this.goToDay()

    }).catch((error) => console.log(error));
  }

  handleInputChange(data) {
    this.setState({ id_sucursal: data.id_sucursal });
    setTimeout( () => {
      this.getProgreso()
    }, 100)
  }

  getAmountByDay(type) {
    let { date, arrDiasVenta, arrDiasGasto, } = this.state
    const dia = moment(date).format('DD')

    if(arrDiasVenta.length === 0)
      return 0

    // if(typeof arrDiasVenta[ dia - 1 ] === 'undefined')
    //   return this.number_format( 0, 2 );

    if(type === 'venta') {
      return this.number_format( arrDiasVenta[ dia - 1 ].venta_pesos, 2 )
    } else if(type === 'gasto') {
      return this.number_format( arrDiasGasto[ dia - 1 ].valor, 2 )
    } else if(type === 'utilidad') {
      return this.number_format( arrDiasVenta[ dia - 1 ].venta_pesos - arrDiasGasto[ dia - 1 ].valor, 2 )
    }

    return 0
  }

  changeActiveItem(activeItemIndex) {
    this.setState({ activeItemIndex });
  }

  render() {
    const { arraySucursales, date, totalVentas, isLoading, groupBy, arrHistoryVentas, } = this.state
    const porcMeta = this.getProgressMeta()
    const { RTDirector } = this.props.initState

    if(!this.state.arrHistoryVentas.list) {
      return (
        <div className="directorPage__wrapper" style={{ marginTop: 150, }}>
          <Lottie
            direction={1}
            options={{
              animationData: animationData,
              loop: true,
            }}
          />
        </div>
      )
    }

    return (
      <div className="directorPage__wrapper" style={{ backgroundColor: '#fff', borderRadius: '' }}>
        {/* Principal div */}
        <Container>
          <Row>
            <div className="initialPage__principalContainer" style={{ backgroundColor: 'transparent', }}>
              <p className={'initialPage__separatorTitle'}>Acumulado mensual</p>
              <Row>
                <Col style={{ textAlign: 'center', marginTop: 5, }}>
                  <p style={{ fontWeight: '800', margin: 0, fontSize: '1.5rem', }}>${ this.number_format(totalVentas.pesos, 2) }</p>
                  <p style={{ color: '#777', }}>{months[ moment(date).format('MM') - 1 ]} { moment(date).format('YY') }</p>
                </Col>
                <Col style={{ textAlign: 'center', marginTop: 5, }}>
                  <p style={{ fontWeight: '800', margin: 0, fontSize: '1.5rem', }}>${this.number_format(totalVentas.pesosMesAnterior, 2)}</p>
                  <p style={{ color: '#777', }}>{months[ moment(date).format('MM') - 1 ]} { moment(date).format('YY') - 1 }</p>
                </Col>
              </Row>

              {/* Gauge global information */}

              <Row>
                <Col className="ventaPage__colHeader" style={{}}>
                  <img style={{ width: 20, height: 20, cursor: 'pointer', float: 'right' }} onClick={() => this.goToDay(0) } src={'img/hgapp/arrow.png'} />
                </Col>
                <Col className="ventaPage__colHeader" style={{}}>
                  <p style={{ textAlign: 'center', fontWeight: '800', }}>{ moment(date).format('DD/MM/YYYY') }</p>
                </Col>
                <Col className="ventaPage__colHeader" style={{}}>
                  <img style={{ width: 20, height: 20, cursor: 'pointer', float: 'left', transform: 'rotate(180deg)' }} onClick={() => this.goToDay(1) } src={'img/hgapp/arrow.png'} />

                </Col>
              </Row>

              {
                /*
                arraySucursales.length > 0 ?
                  <Select
                    placeholder="Dirección"
                    // defaultInputValue="Dirección"
                    options={this.state.arraySucursales}
                    onChange={(val) => {this.handleInputChange(val)}}
                    styles={customStyles} />
                : null
                */
              }              

              <Row>

                <Col className="ventaPage__colTypes" style={{ textAlign: 'center', borderTop: '5px solid #da3a2f' }}>
                  <p><b>${ this.number_format(arrHistoryVentas.total,2) }</b></p>
                  <p><b>Venta</b></p>
                </Col>
                <Col className="ventaPage__colTypes" style={{ textAlign: 'center', borderTop: '5px solid #da3a2f' }}>
                  <p><b>${ this.number_format(arrHistoryVentas.total_pcompra,2) }</b></p>
                  <p><b>Compra</b></p>
                </Col>
                <Col className="ventaPage__colTypes" style={{ textAlign: 'center', borderTop: '5px solid black' }}>
                  <p><b>${ this.number_format(arrHistoryVentas.gastos,2) }</b></p>
                  <p><b>Gasto</b></p>
                </Col>
                <Col className="ventaPage__colTypes" style={{ textAlign: 'center', borderTop: '5px solid green' }}>
                  <p><b>${ this.number_format( (arrHistoryVentas.abonos) ,2) }</b></p>
                  <p><b>Abonos</b></p>
                </Col>
                <Col className="ventaPage__colTypes" style={{ textAlign: 'center', borderTop: '5px solid green' }}>
                  <p><b>${ this.number_format( ((arrHistoryVentas.total + arrHistoryVentas.abonos) - (arrHistoryVentas.total_pcompra)) ,2) }</b></p>
                  <p><b>Utilidad</b></p>
                </Col>
              </Row>

              {
                /*
                <Row>
                  <Col style={{ textAlign: 'center', marginTop: 20, }}>
                    <div style={{ width: '100%', height: 20, border: '1px solid #ccc', borderRadius: 10, padding: 2, }}>
                      <div style={{ height: 14, width: `${(((arrHistoryVentas.utilidad + arrHistoryVentas.abonos) / arrHistoryVentas.total) * 100)}%`, backgroundColor: '#da3a2f', borderRadius: 10, }}></div>
                    </div>
                    <p><b>Meta $15,000.00 ({ this.number_format( ((arrHistoryVentas.utilidad + arrHistoryVentas.abonos) / (arrHistoryVentas.total)) * 100, 0 ) }%)</b></p>
                  </Col>
                </Row>
                */
              }
              {
                RTDirector.text != '' ? (
                  <p><b>{RTDirector.text}</b></p>
                ) : null
              }
              <ItemsCarousel
                enablePlaceholder={false}
                numberOfPlaceholderItems={4}
                minimumPlaceholderTime={1000}
                placeholderItem={<div style={{ height: 200, background: '#900' }}></div>}
                numberOfCards={2}
                gutter={10}
                showSlither={true}
                firstAndLastGutter={true}
                freeScrolling={false}
                requestToChangeActive={ (index) => {this.changeActiveItem(index)} }
                activeItemIndex={this.state.activeItemIndex}
                activePosition={'center'}
                chevronWidth={10}
                rightChevron={<button className={'btn__itemcarouselChevron'}>{'>'}</button>}
                leftChevron={<button className={'btn__itemcarouselChevron'}>{'<'}</button>}
                outsideChevron={false}
                >
                {
                (this.state.arrHistoryVentas.list) && this.state.arrHistoryVentas.list.map((t,e) => (
                  <div className={'directorPage__carousel_container'} onClick={() => { this.onInfoBySucursal(t,e) }} key={1} style={{ background: this.getColorByIndex(e) }}>
                    <div className={'directorPage__carousel_utilidad'}>
                      <p className={'directorPage__carousel_valNumber'}>${`${this.number_format( (t.total - t.total_pcompra) - t.gastos_fijos , 2)}`}</p>
                      <p className={'directorPage__carousel_text'}>Utilidad ({ `${ this.number_format((t.utilidad / t.total) * 100, 2) }%` })</p>
                      <div className={'directorPage__carousel_progressBar'}>
                        <div style={{ background: '#2ed573', width: `${ this.number_format((t.utilidad / t.total) * 100, 2) }%` }}></div>
                      </div>
                    </div>
                    <div className={'directorPage__carousel_total'}>
                      <p className={'directorPage__carousel_valNumber'}>${`${this.number_format(t.total, 2)}`}</p>
                      <p className={'directorPage__carousel_text'}>Ventas</p>
                    </div>
                    <div className={'directorPage__carousel_total'}>
                      <p className={'directorPage__carousel_valNumber'}>${`${this.number_format(t.total_pcompra, 2)}`}</p>
                      <p className={'directorPage__carousel_text'}>Compra</p>
                    </div>
                    <div className={'directorPage__carousel_total'}>
                      <p className={'directorPage__carousel_valNumber'}>${`${this.number_format(t.credito, 2)}`}</p>
                      <p className={'directorPage__carousel_text'}>Créditos</p>
                    </div>
                    <div className={'directorPage__carousel_gastos'}>
                      <p className={'directorPage__carousel_valNumber'}>${`${this.number_format(t.gastos, 2)}`}</p>
                      <p className={'directorPage__carousel_text'} style={{ lineHeight: '14px', }}>Gasto a proveedores / préstamos ({ `${ this.number_format((t.gastos / t.total) * 100, 2) }%` })</p>
                      <div className={'directorPage__carousel_progressBar'}>
                        <div style={{ background: '#ff4757', width: `${ this.number_format((t.gastos / t.total) * 100, 2) }%` }}></div>
                      </div>
                    </div>
                    <div className={'directorPage__carousel_gastos'}>
                      <p className={'directorPage__carousel_valNumber'}>${`${this.number_format(t.gastos_fijos, 2)}`}</p>
                      <p className={'directorPage__carousel_text'} style={{ lineHeight: '14px', }}>Gasto fijo diario ({ `${ this.number_format((t.gastos_fijos / t.total) * 100, 2) }%` })</p>
                      <div className={'directorPage__carousel_progressBar'}>
                        <div style={{ background: '#ff4757', width: `${ this.number_format((t.gastos_fijos / t.total) * 100, 2) }%` }}></div>
                      </div>
                    </div>
                    <div className={'directorPage__carousel_total'}>
                      <p className={'directorPage__carousel_valNumber'}>${`${this.number_format(t.parciales, 2)}`}</p>
                      <p className={'directorPage__carousel_text'}>Parciales</p>
                    </div>
                    <div className={'directorPage__carousel_total'}>
                      <p className={'directorPage__carousel_valNumber'}>${`${this.number_format(t.abonos, 2)}`}</p>
                      <p className={'directorPage__carousel_text'}>Abonos</p>
                    </div>
                    <p className={'directorPage__carousel_name'}>{t.nombre}</p>
                  </div>
                ))
                }
              </ItemsCarousel>

              <button onClick={() => { this.props.initsetState({ viewApp: 'tabla_diaria_productos', }) }} className={'btn btn-primary'}>Ver tabla general</button>
              <button onClick={() => { this.props.initsetState({ viewApp: 'tabla_productividad_general', }) }} className={'btn btn-primary'}>Ver productividad del mes</button>
            </div>
          </Row>
        </Container>
      </div>
    );
  }

  onInfoBySucursal(t,e) {
    let { tabsArray, arrSucursalSelected } = this.props.initState

    for(var a in tabsArray) {
      tabsArray[a].active = 0
      if( tabsArray[a].index === 2 ) {
        //Sección sucursal
        tabsArray[a].active = 1
      }
    }
    this.props.initsetState({ arrSucursalSelected: {e, t}, tabsArray, })

  }
  makeListProductsBySucursal() {
    const { arrHistoryVentas, indexViewProducts } = this.state
    if(arrHistoryVentas.length === 0) {
      return null
    }

    return (
      <>
        {
          arrHistoryVentas.list.map((t,e) => (
            <Row
              key={`ws_list_compra_${e}`}
              style={{ width: '100%', margin: '0 auto', marginTop: 10, }}
              className="regVentaPage__content"
              onClick={() => { this.setState({indexViewProducts: (indexViewProducts === e ? -1 : e) }) }}
            >
              <div className="regVentaPage__separator"></div>
              <Col className="regVentaPage__listProduct">
                <p style={{ color: '#333', padding: 0, lineHeight: '25px', }}>{t.nombre}</p>
              </Col>
              <Col className="regVentaPage__listPrices" xs={7}>
                <p className="lprices__amount">${ this.number_format( (t.total) , 2) }</p>
              </Col>

              {
                indexViewProducts === e ? (
                <>
                {
                  t.list.map((t0, e0) => (
                    <Row
                      key={`ws_list_product_${e0}`}
                      style={{ width: '80%', margin: '0 auto', marginTop: '0px !important', background: '#fff', }}
                      className="regVentaPage__content"
                    >
                      <div className="regVentaPage__separator"></div>
                      <Col className="regVentaPage__listProduct">
                        <p style={{ color: '#333', padding: 0, lineHeight: '25px', }}><b>{t0.nombre}</b></p>
                        <p style={{ color: '#333', padding: 0, lineHeight: '25px', }}>Hora: {t0.hora}</p>
                      </Col>
                      <Col className="regVentaPage__listPrices" xs={7}>
                        <p className="lprices__amount">${ this.number_format( (t0.venta_pesos) , 2) }</p>
                        <p className="lprices__kg">{ this.number_format(t0.venta_kg, 2) } KG</p>
                      </Col>
                    </Row>
                  ))
                }
                </>
                ) : null
              }

            </Row>
          ))
        }
      </>
    )
  }

  makeListProductsByCategoria() {
    const { arrHistoryVentas, indexViewProducts } = this.state
    if(arrHistoryVentas.length === 0) {
      return null
    }

    return (
      <>
        {
          arrHistoryVentas.map((t,e) => (
            <Row
              key={`ws_list_compra_${e}`}
              style={{ width: '100%', margin: '0 auto', marginTop: 10, }}
              className="regVentaPage__content"
              onClick={() => { this.setState({indexViewProducts: (indexViewProducts === e ? -1 : e) }) }}
            >
              <div className="regVentaPage__separator"></div>
              <Col className="regVentaPage__listProduct">
                <p style={{ color: '#333', padding: 0, lineHeight: '25px', }}>{t.nombre}</p>
              </Col>
              <Col className="regVentaPage__listPrices" xs={7}>
                <p className="lprices__amount">${ this.number_format( (t.total) , 2) }</p>
              </Col>

              {
                indexViewProducts === e ? (
                <>
                {
                  t.list.map((t0, e0) => (
                    <Row
                      key={`ws_list_product_${e0}`}
                      style={{ width: '80%', margin: '0 auto', marginTop: '0px !important', background: '#fff', }}
                      className="regVentaPage__content"
                    >
                      <div className="regVentaPage__separator"></div>
                      <Col className="regVentaPage__listProduct">
                        <p style={{ color: '#333', padding: 0, lineHeight: '25px', }}><b>{t0.nombre}</b></p>
                        <p style={{ color: '#333', padding: 0, lineHeight: '25px', }}>Hora: {t0.hora}</p>
                      </Col>
                      <Col className="regVentaPage__listPrices" xs={7}>
                        <p className="lprices__amount">${ this.number_format( (t0.venta_pesos) , 2) }</p>
                        <p className="lprices__kg">{ this.number_format(t0.venta_kg, 2) } KG</p>
                      </Col>
                    </Row>
                  ))
                }
                </>
                ) : null
              }

            </Row>
          ))
        }
      </>
    )
  }

  makeListProducts() {
    const { arrHistoryVentas } = this.state
    if(arrHistoryVentas.length === 0) {
      return null
    }

    return (
      <>
        {
          arrHistoryVentas.map((t,e) => (
            <Row
              key={`ws_list_compra_${e}`}
              style={{ width: '100%', margin: '0 auto', marginTop: 10, }}
              className="regVentaPage__content"
            >
              <div className="regVentaPage__separator"></div>
              <Col className="regVentaPage__listProduct">
                <p style={{ color: '#333', padding: 0, lineHeight: '25px', }}><b>{t.nombre}</b></p>
                <p style={{ color: '#333', padding: 0, lineHeight: '25px', }}>{t.nombre_sucursal}</p>
                <p style={{ color: '#333', padding: 0, lineHeight: '25px', }}>Hora: {t.hora}</p>
              </Col>
              <Col className="regVentaPage__listPrices" xs={7}>
                <p className="lprices__amount">${ this.number_format( (t.venta_pesos * t.venta_kg) , 2) }</p>
                <p className="lprices__kg">{ this.number_format(t.venta_kg, 2) } KG</p>
              </Col>
            </Row>
          ))
        }
      </>
    )
  }

  getProgressMeta() {
    let utilidad = this.getAmountByDay('utilidad')
    let meta = 0

    if(utilidad !== 0) {
      utilidad = utilidad.replace('$', '').replace(',', '')
      meta = ((utilidad / 15000) * 100)
    }

    return {
      porc: (meta > 100 ? 100 : meta) + '%',
      val: meta
    }
  }

  goToDay(opt) {
    const { date, arrDiasVenta } = this.state
      let d = new Date(date)

    const dia = moment(date).format('DD')
    const mes = moment(date).format('MM')
    if(opt === 0) {
      //Pa atrás
      let dayAnt = parseInt(dia) - 1
      if(dayAnt < 1) {
        //Ya va para otro mes atrás
        d.setMonth( mes - 2 )
        let newDate = new Date(d)
        d.setDate( new Date( moment(newDate).format('YY')  , moment(newDate).format('MM'), 0).getDate() )

        this.setState({
          isLoading: true,
          arrDiasVenta: [],
          arrDiasGasto: [],
          // arrHistoryVentas: [],
        })

        setTimeout(() => {
          this.setState({
            date: new Date(d),
            dateDire: new Date(d),
            // arrHistoryVentas: [],
          }, this.getProgreso)
        }, 1000)
      } else {
        d.setDate( dayAnt )
        this.setState({
          date: new Date(d),
          dateDire: new Date(d),
        })
      }
    } else if(opt === 1) {
      //Pa adelante
      let dayNext = parseInt(dia) + 1

      if(parseInt(dayNext) > arrDiasVenta.length) {
        return false
      }
      d.setDate( dayNext )
      this.setState({
        // arrHistoryVentas: [],
        date: new Date(d),
        dateDire: new Date(d),
      })
    } else {
      this.setState({
        // arrHistoryVentas: [],
      })
    }

    setTimeout(() => {
      if(this.getAmountByDay('venta') !== '0.00' || this.state.date === moment().format('YYYY-MM-DD')) {
        fetch(this.getURLByOPT('getListadoVentaByDia'), this.headersPOST({ date: this.state.date, groupBy: this.state.groupBy }))
        .then(response => response.json())
        .then((response) => {
          let { arrHistoryVentas, } = response
          this.setState({
            arrHistoryVentas,
          })
        }).catch((error) => console.log(error));

        fetch(`https://hg.wsoft.com.mx/REST/controllers/controllerPreproduction.php?opt=getListGeneralUtilidades`, this.headersPOST({ date: moment(this.state.date).format('YYYY-MM-DD'), }))
        .then(response => response.json())
        .then((response) => {
          let { list, } = response;
          this.setState({
            arrListUtilidades: list,
          })
        }).catch((error) => console.log(error));
      }

    }, 500)

  }

  initsetState(param) {
    this.props.initsetState(param)
    return true
  }

  number_format(number, decimals, decPoint, thousandsSep) {
    number = (number+'').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return ''+(Math.round(n * k) / k)
      .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : ''+Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length+1).join('0')
    }
    return s.join(dec)
  }

  uniqid() {
    var pr = '', en = false, result;this.seed = function (s, w) {s = parseInt(s, 10).toString(16);return w < s.length ? s.slice(s.length - w) : (w > s.length) ? new Array(1 + (w - s.length)).join('0') + s : s;};result = pr + this.seed(parseInt(new Date().getTime() / 1000, 10), 8) + this.seed(Math.floor(Math.random() * 0x75bcd15) + 1, 5);if (en) {result += (Math.random() * 10).toFixed(8).toString();} return result;
  }

  getColorByIndex(e) {
    const color = ['#F0F4FE','#A7CDF2','#E2EFE3','#8FAEE3','#F0F4FE','#A7CDF2','#E2EFE3','#8FAEE3']
    return color[e]
  }

  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

  getURLByOPT(opt) {
    let PHP = this.props.initState.debug === 1 ? 'controllerPreproduction.php' : 'controllerWebApp.php'
    return `https://hg.wsoft.com.mx/REST/controllers/${PHP}?opt=${opt}`
  }

};

export default withRouter(MainProgresoPage)